import { render, staticRenderFns } from "./GradingItem.vue?vue&type=template&id=344d5908&scoped=true&"
import script from "./GradingItem.vue?vue&type=script&lang=js&"
export * from "./GradingItem.vue?vue&type=script&lang=js&"
import style0 from "./GradingItem.vue?vue&type=style&index=0&id=344d5908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344d5908",
  null
  
)

export default component.exports